import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Star, Sparkles } from 'lucide-react';
export const FloatingElements = () => {
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-0" data-id="element-24">
      <motion.div className="absolute top-20 left-[10%] text-pink-300 opacity-60" animate={{
      y: [0, -20, 0],
      rotate: [0, 10, -10, 0]
    }} transition={{
      duration: 5,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-25">
        <Heart size={40} fill="currentColor" data-id="element-26" />
      </motion.div>
      <motion.div className="absolute top-40 right-[15%] text-pink-400 opacity-50" animate={{
      y: [0, 30, 0],
      rotate: [0, -15, 15, 0]
    }} transition={{
      duration: 7,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 1
    }} data-id="element-27">
        <Star size={32} fill="currentColor" data-id="element-28" />
      </motion.div>
      <motion.div className="absolute bottom-32 left-[20%] text-pink-200 opacity-70" animate={{
      y: [0, -25, 0],
      scale: [1, 1.2, 1]
    }} transition={{
      duration: 6,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 2
    }} data-id="element-29">
        <Sparkles size={48} data-id="element-30" />
      </motion.div>
      <motion.div className="absolute bottom-40 right-[10%] text-pink-300 opacity-60" animate={{
      y: [0, -15, 0],
      rotate: [0, 45, 0]
    }} transition={{
      duration: 8,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 0.5
    }} data-id="element-31">
        <Heart size={24} fill="currentColor" data-id="element-32" />
      </motion.div>
    </div>;
};